import type { JSX, ReactNode } from 'react';

import { cn } from '@/lib/cn';

interface CardProps {
  children: ReactNode;
  className?: string;
  /** Adds a hover affordance. Only use on cards that are entirely clickable. */
  interactive?: boolean;
  as?: 'div' | 'article' | 'li' | 'section';
}

export function Card({
  children,
  className,
  interactive = false,
  as: Element = 'div',
}: CardProps): JSX.Element {
  return (
    <Element
      className={cn(
        'rounded-lg border border-line bg-surface p-6',
        interactive &&
          'transition-[border-color,box-shadow,transform] duration-200 ' +
            'hover:-translate-y-0.5 hover:border-line-strong hover:shadow-card ' +
            'focus-within:border-line-strong focus-within:shadow-card',
        className,
      )}
    >
      {children}
    </Element>
  );
}
